export default __webpack_public_path__ + "static/desktopTerminal-d184873154d448ddd502655bcdfd070e.svg";